import { signInWithCustomToken } from "firebase/auth";

// Auth state management
const authState = reactive({
  isLoading: false,
  error: null,
  isAuthenticating: false,
});

async function signIn(token: string) {
  const { $firebase } = useNuxtApp();

  try {
    authState.isLoading = true;
    authState.error = null;

    const userCredential = await signInWithCustomToken(($firebase as any).auth, token);
    const user = userCredential.user;

    console.log("User signed in successfully:", user.email);
    return user;
  } catch (e: any) {
    console.error("Sign-in error:", e);
    authState.error = e.message || "Authentication failed";
    throw e;
  } finally {
    authState.isLoading = false;
  }
}

// Enhanced redirect function with better error handling
function redirectToSignIn() {
  try {
    const config = useRuntimeConfig();
    const redirectUrl = encodeURIComponent(window.location.href);
    const signInUrl = `${config.public.kpUrl}/sign-in?redirect=${redirectUrl}`;

    console.log("🔄 Redirecting to sign-in:", signInUrl);
    window.location.href = signInUrl;
  } catch (error) {
    console.error("Redirect error:", error);
    // Fallback to basic redirect
    const config = useRuntimeConfig();
    window.location.href = `${config.public.kpUrl}/sign-in`;
  }
}

// Check if user should be redirected to sign-in
function requireAuth() {
  const userStore = useUserStore();

  if (!userStore.isLoggedIn) {
    redirectToSignIn();
    return false;
  }

  return true;
}

// Get redirect URL from query params only (more secure)
function getRedirectUrl() {
  const route = useRoute();
  const redirectFromQuery = route.query.redirect;

  if (redirectFromQuery) {
    try {
      const decodedUrl = decodeURIComponent(redirectFromQuery);

      // Security check: only allow redirects to same origin or trusted domains
      const currentOrigin = window.location.origin;
      const redirectOrigin = new URL(decodedUrl).origin;

      // Allow same origin or trusted external domains
      const config = useRuntimeConfig();
      const trustedDomains = [
        currentOrigin,
        config.public.kpUrl,
        // Add other trusted domains as needed
      ];

      if (trustedDomains.includes(redirectOrigin)) {
        console.log("Valid redirect URL:", decodedUrl);
        return decodedUrl;
      } else {
        console.warn("Untrusted redirect URL:", decodedUrl);
        return "/";
      }
    } catch (error) {
      console.error("Invalid redirect URL:", error);
      return "/";
    }
  }

  return "/";
}

// Store redirect URL in OAuth flow (pass through URL chain)
function storeRedirectUrl() {
  const currentUrl = window.location.href;
  console.log("📝 Storing redirect URL for OAuth flow:", currentUrl);
  return currentUrl;
}

export { signIn, redirectToSignIn, requireAuth, getRedirectUrl, storeRedirectUrl, authState };
